module.exports = __webpack_public_path__ + "static/media/扫码成功.dc6d2.png";